import { NgModule } from '@angular/core';
import { SdAddCompanyModule } from './add-company';

@NgModule({
  imports: [SdAddCompanyModule],
})
export class SdvorCompanyUiModule {}
